<template>
  <BootstrapModal class="EditAccount"
    v-on="$listeners"

    @save="saveAccount"
  >
    <div>
      <FormInput v-model="$v.name.$model"
        id="site"
        label="Website"

        :vuelidate="$v"
        fieldName="site"
      />
      <div class="d-flex">
        <FormInput v-model="$v.name.$model"
          class="sm form-element"
        
          id="orderNumber"
          label="Bestellingsnummer"
    
          :vuelidate="$v"
          fieldName="orderNumber"
        />
        <FormDatePicker v-model="$v.orderDate.$model"
          class="sm form-element"

          id="orderNumber"
          label="Date"

          :vuelidate="$v"
          fieldName=""
        />
      </div>
    </div>

    <template #title>
      Bestelling toevoegen
    </template>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"
import FormDatePicker from "/src/components/Inputs/FormDatePicker.vue"
import FormInput from "/src/components/Inputs/FormInput.vue"

import tableFieldOptions from "/src/mixins/tableFieldOptions"

export default {
  mixins: [tableFieldOptions],
  components: {
    BootstrapModal,
    FormDatePicker,
    FormInput,
  },
  data() {
    return {
      websites: [],
      status: null,
      role: null,
      name: "",
      email: "",
    }
  },
  created() {
    const account = this.account
    if (account) {
      this.websites = account.websites.slice()
      this.status = account.account
      this.$v.name.$model = account.name
      this.$v.email.$model = account.email
      this.role = account.role
    }
  },
}

</script>

<style scoped src="@/assets/css/form.css"></style>
